import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  DatePicker,
  Checkbox
} from "antd";
import Container from "../../../../components/user/Container";
import { changeFormatdate, checkMoreThanLess } from "../../../../utils/formatdate";
import { alertMessage } from '../../../../utils/message';
import { UrlAbstainTime, getToken } from '../../../../utils/auth';
import axios from 'axios';
import { apiKeyNews } from '../../../../utils/apiKey'
import { checkStatusForm, sumTotalAbstainDate } from '../../../../utils/abstainTime'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import moment from "moment";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;

const newsDataProfile = "";

class Dashboard extends Component {
   state = {
      loading: true,
      loadingFullpage: true,
      dataTalbe:[],
      selectStatus: '',
      columns: [
         {
               title: () => {
               return <Checkbox 
                        disabled={ this.state.selectStatus == 'pending' || this.state.selectStatus == ''  ? false : true }
                        checked={ this.state.checkBoxTitle }
                        // className="checkBox-select"
                        onChange={
                           (e) => this.onChangeSlectAll(e.target.checked)}
                        >
                     </Checkbox>
         },
            dataIndex: 'statusCheckBox',
            width:90,
            align:"center",
            render: (item, record, index) => { 
               return 	<Checkbox 
                  // className="checkBox-select"
                           checked={item} 
                           disabled={ record.status == 'pending' ? false : true }
                           onChange={(e) => this.onChangeSlectTable(e.target.checked, record.approverId, index, record)}
                           >
                        </Checkbox>
            }
         },
         {
            // title: 'เลขที่เอกสาร',
            title: "เลขที่เอกสาร",
            dataIndex: "documentNo",
            width: 150,
            // align:'center',
            render: (item, record, index) => <span>{item}</span>,
            // render: (item, record, index) => <span>{ item }</span>
         },
         {
            // title: 'เลขที่เอกสาร',
            title: "รหัสบุคลากร",
            dataIndex: "empCode",
            width: 150,
            render: (item, record, index) => <span>{item}</span>,
            // align:'center',
         },
         {
            // title: 'เลขที่เอกสาร',
            title: "ชื่อ-นามสกุล",
            dataIndex: "documentNo",
            width: 200,
            render: (item, record, index) => <span>{record.title+''+record.firstName+' '+record.lastName}</span>,
         },
         {
            title: "วันที่ยื่นเรื่อง",
            dataIndex: "createdAt",
            width: "150px",
            align: "center",
            render: (item, record, index) => (
               <span>{ changeFormatdate(moment(item)) }</span>
            
            ),
         },
         {
            title: "จำนวนวันที่ขอยกเว้น",
            dataIndex: "abstainTotalDate",
            width: "150px",
            align: "center",
            render: (item, record, index) => (
               <span>{ item ? item : 0}</span>
            ),
         },
         {
            title: "สถานะ",
            dataIndex: "status",
            align: "center",
            // render: (item, record, index) => <span>{}</span>
            width: "130px",
            render: (item, record, index) => (
                  <span>{ checkStatusForm(item) }</span>
            ),
         },
         
         {
         title: "รายละเอียด",
         dataIndex: "7",
         align: "center",
         width: 100,
         fixed: "right",
         render: (item, record, index) => {
            return (
               <>
               <Link
                  to={{
							pathname: 'Confirm/'+record.approverId,
							state: {
								approverId: record.approverId,
                        statusForm: record.status,
							}
						}}
               >
                  <Icon type="form" className="mr-2" style={{ color: "#000" }} />
                  {/* { record.wdLeaveId } */}
               </Link>
               </>
            );
         },
         },
      ],
      offset: 0,
      limit: 10,
      pagination: {
         total: 10,
      },
      disabledDateStart: moment(new Date()).add(-1, "year"),
      endStartValues: moment(new Date()).add(1, "year"),
      valueStatus: "A",
      preLoadSubmit: false,
      formValue: null,
      dropdownLeaveType: [],
      currentPage: 1,
      loginPerson: [],
      dataSelectTable: []
   };

   onChangeSlectAll = async (value) =>{
		const { dataTalbe } = this.state
		let arrayNewsDataTable = []
		const rowsDataSelectTable = []
		const rows = null
      // console.log('arrayNewsDataTable', dataTalbe)
		if(value){
			await dataTalbe.map((values, keys)=>{
            if(values.status == 'pending'){
               values.statusCheckBox = value
               arrayNewsDataTable[keys] = values
               rowsDataSelectTable.push({
                        approverId:values.approverId, 
                        abTimeHdId: values.relatedDocId,
                     })
            }else{
               values.statusCheckBox = false
               arrayNewsDataTable[keys] = values
            }
				
			})
		}else{
			await dataTalbe.map((values, keys)=>{
				values.statusCheckBox = value
				arrayNewsDataTable[keys] = values
			})
		}

		await this.setState({
			dataTalbe: arrayNewsDataTable,
			dataSelectTable:rowsDataSelectTable,
			checkBoxTitle:value
		})
		
	}
     
    onChangeSlectTable = async(values, approverId, arrayId, record) =>{
        let dataSourceitems = [...this.state.dataSelectTable];
        let keysdataSelectTable = null

        let dataSourceitemsTable = [...this.state.dataTalbe];
        let item = {...dataSourceitemsTable[arrayId]};
        item.statusCheckBox = values

        dataSourceitemsTable[arrayId] = item;

        await this.setState({
            dataTalbe:dataSourceitemsTable
        },() => {
            // this.cllBackSetValueContactNumber()
        })

        dataSourceitems.map(async(filtereditem, keys) =>{
            if(filtereditem.approverId == approverId){
                keysdataSelectTable = keys
            }
        })

        if(values){
            const rows = {
               approverId: record.approverId,
               abTimeHdId: record.relatedDocId,
            }
            await this.setState(prevState => ({
                dataSelectTable: [...prevState.dataSelectTable, rows],
            }), () => {
                // this.cllBackSetValueOrganizatuions()
            })
        }else{
            dataSourceitems.filter(item => item.approverId == approverId).map((filtereditem) => {
                var arrayDataSource = [...this.state.dataSelectTable];
                    arrayDataSource.splice(keysdataSelectTable, 1);
                    
                    this.setState({
                        dataSelectTable:arrayDataSource,
                    },() => {
                    // this.cllBackSetValueContactNumber()
                    })
            })
        }
    }

   fetchProfile = async () => {
      try {
         const { client } = this.props;
         const { data } = await client.query({
         query: Queries.fetchProfile,
         });

         await this.setState({
            loginPerson: data.fetchProfile,
            employeeCodes: data.fetchProfile.employeeCodes[0]
         });
         // return data.fetchProfile

         if(data.fetchProfile){
            try {
               await this.getAbstainTimeForApproverList(data.fetchProfile.employeeCodes[0])
            } catch (e) {}
         }else{

         }
        
      } catch (e) {}

   };

   paginationChange = async (e) => {
      const { formValue, empCode } = this.state;
      const { form, afterSubmit, client } = this.props;
      // await e.preventDefault()

      // console.log("pagination e",e)
      // console.log("pagination values",values)

      form.validateFields(async (err, values) => {
         console.log("values pagination", values);
         await this.setState({
         formValue: values,
         });

         console.log("paginationChange formvalue", values);

         if (!err) {
         try {
            let offset = 0;
            if (e.current === 1) {
               offset = 0;
            } else {
               offset = e.current - 1 + "0";
            }

            await this.setState({
               pageData: {
               offset: parseInt(offset),
               limit: 10,
               },
            });
            await this.setState({
               pageData: {
               offset: parseInt(offset),
               limit: 10,
               },
               currentPage: e.current,
            });

            // await this.fetchListPost()
            if (formValue) {
               console.log("paginationChange formvalue!!", values);
               await this.fetchListStudyLeaveRequestSearchPagi(values);
            } else {
               await this.fetchListStudyLeaveRequest();
            }
         } catch (error) {
            console.log("error", error);
         }
         }
      });
   };

   handleSubmit = async (e) => {
      const { form, afterSubmit, client } = this.props
      const { employeeCodes } = this.state
		await e.preventDefault()
		let dataTalbeArray = []
		form.validateFields(async (err, values) => {
			await this.setState({
				formValue: e,
				loading:true
			})

			// await this.fetchLeaveDocumentList(values)
			if (!err) {
            try {
               const { token } = getToken()
               const API_DEVICE_KEY = atob(apiKeyNews())
         
               const headers = {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`,
                  'apiKey': API_DEVICE_KEY
                }
         
               // axios.get(`${UrlAbstainTime()}/getAbstainTimeForApproverList?empCode=${employeeCodes}?searchKeyWord=${null}?status=${values.status ? values.status : ''}`,
               axios.get(`${UrlAbstainTime()}/getAbstainTimeForApproverList`,
               {
                  params: {
                     empCode: employeeCodes,
                     searchKeyWord: values.searchKeyWord,
                     status: values.status,
                   },
                  headers: headers
               })
               .then(async (response) => {
                  let dataTalbeArray = []
                  if(response.data.data){
                     await response.data.data.map((valuesList, keys) =>{
                        valuesList.statusCheckBox = false
                        dataTalbeArray.push(valuesList);
                     })
            
                     await this.setState({
                        dataTalbe: dataTalbeArray,
                        loadingFullpage: false,
                        loading: false,
                     })
                  }else{
                     await this.setState({
                        preLoadSubmit:false,
                        loadingFullpage: false,
                        loading: false,
                     })
                  }
               }).catch(
                  error => console.error(`Error: ${error}`)
               )
            }catch (error) {
               console.log('error',error)
            }
			}
		})
	}

   getAbstainTimeForApproverList = async (empCode) => {
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, disabledDateStart, endStartValues } = this.state;

      console.log('123123,', empCode)
      await this.setState({
         loading: true,
      });

      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.get(`${UrlAbstainTime()}/getAbstainTimeForApproverList`,
      {
         params: {
            empCode,
            status: "pending",
          },
         headers: headers
      })
      .then(async (response) => {
         let dataTalbeArray = []
         console.log('response.data.data', response.data.data)
         if(response.data.data){
            await response.data.data.map((valuesList, keys) =>{
               valuesList.statusCheckBox = false
               dataTalbeArray.push(valuesList);
            })
   
            await this.setState({
               dataTalbe: dataTalbeArray,
               loadingFullpage: false,
               loading: false,
            })
         }else{
            await this.setState({
               preLoadSubmit:false,
               loadingFullpage: false,
               loading: false,
            })
         }
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

   showModalFormConfirm = async (
      status, 
      messageForm, 
      title , 
      textBtnOK, 
      ModalFormTextArea, 
      ModalFormTextAreaRequie
   ) =>{
      const { form, client } = this.props
      const { dataSelectTable } = this.state
         
         this.setState({
            preLoadOnsubmit: true
         })

      if(dataSelectTable.length !== 0){
         await this.setState({
            ModalConfirmFormTitle:title,
            ModalConfirmFormSubTitle:'',
            ModalConfirmFormShowModal:true,
            ModalConfirmFormBtnOk:textBtnOK,
            ModalConfirmFormBtnCancel:'ยกเลิก',
            ModalConfirmFormValue:{},
            ModalConfirmFormStatus:status,
            ModalConfirmFormMessage: messageForm,
            ModalFormTextArea,
            ModalFormTextAreaRequie
         })
      }else{
         let content = ''
         // message.warning('กรุณาเลือกเอกสาร อย่างน้อย 1 รายการ');
         if(status == 'REJECT'){
            content = 'กรุณาเลือกเอกสารที่ไม่อนุมัติรายการขอเบิก'
         }else if(status == 'APPROVE'){
            content = 'กรุณาเลือกเอกสารที่จะทำการอนุมัติรายการขอเบิก'
         }else if(status == 'MOREINFO'){
            content = 'กรุณาเลือกเอกสารที่จะทำการขอเอกสารเพิ่มเติมรายการขอเบิก'
         }

         alertMessage("warning",content)
      }
   }

   hideModalConfirm = async () =>{
      await this.setState({
          ModalConfirmFormTitle:null,
          ModalConfirmFormSubTitle:null,
          ModalConfirmFormShowModal:false,
          ModalConfirmFormBtnOk:null,
          ModalConfirmFormBtnCancel:null,
          ModalConfirmFormValue:null,
          ModalConfirmFormStatus:null,
         ModalConfirmFormMessage:null
      })
  }

   submitReject = async () =>{
		const { dataSelectTable } = this.state

		if(dataSelectTable.length !== 0){
			// await this.setToApprover('N', 'ไม่อนุมัติรายการขอลาที่เลือกเรียบร้อย')
         await this.showModalFormConfirm(
                  'reject', 
                  'ไม่อนุมัติรายการแก้ไขการลงเวลาทำงานที่เลือกเรียบร้อย', 
                  'ท่านไม่อนุมัติรายการแก้ไขการลงเวลาทำงาน', 
                  'ยืนยัน',
                  true,
                  true,
               )
		}else{
			message.warning({
				content: 'กรุณาเลือกเอกสารที่จะไม่อนุมัติรายการแก้ไขการลงเวลาทำงาน',
				key:'1',
				duration: 2,
			})
		}
	}

	submitApprover = async () =>{
		const { dataSelectTable } = this.state

		if(dataSelectTable.length !== 0){
			// await this.setToApprover('Y', 'ทำการอนุมัติรายการขอลาที่เลือกเรียบร้อย')
         await this.showModalFormConfirm(
            'approve', 
            'ทำการอนุมัติรายการแก้ไขการลงเวลาทำงานที่เลือกเรียบร้อย', 
            'ท่านต้องการอนุมัติรายการแก้ไขการลงเวลาทำงาน', 
            'ยืนยัน',
            true,
            false,
         )
		}else{
			message.warning({
				content: 'กรุณาเลือกเอกสารที่จะอนุมัติรายการแก้ไขการลงเวลาทำงาน',
				key:'1',
				duration: 2,
			})
		}
	}

   setToApprover = async (values) =>{
      const { form, afterSubmit, client } = this.props
		const { 
            dataSelectTable, 
            formValue,
            ModalConfirmFormMessage,
            ModalConfirmFormStatus,
            employeeCodes
         } = this.state

		let constSelect = dataSelectTable.length
      let bulk = {}
		
		try {
        let body =  dataSelectTable.map((valuesSelect , keys) => (
        
               {
                  approverId: valuesSelect.approverId,
                  abTimeHdId: valuesSelect.abTimeHdId,
                  approveAction: ModalConfirmFormStatus,
                  description: values.ModalNoteApprove
               }
         ))
         
         bulk = {
            bulk:body
         }

         
         const { token } = getToken();
         const API_DEVICE_KEY = atob(apiKeyNews());

         const headers = {
            //"Content-Type": 'multipart/form-data',
            Authorization: `Bearer ${token}`,
            apiKey: API_DEVICE_KEY,
          };
      
          console.log('123132', bulk)
          axios
            .post(
              `${UrlAbstainTime()}/multipleApproveAbstainTime`,
               bulk
              ,
              {
                headers: headers,
              }
            )
            .then(async (response) => {
              console.log("response", response);
              await this.hideModalConfirm();

              await this.setState({
                  dataSelectTable:[],
               })

              alertMessage("success",ModalConfirmFormMessage)
              console.log('formValue', formValue)
              if(formValue){
                  await this.handleSubmit(formValue)
               }else{
                  await this.getAbstainTimeForApproverList(employeeCodes)
               }
            })
            .catch((error) => console.error(`Error: ${error}`));
      

		}catch (error) {
			console.log('error',error)
		}
	}

   onChangeStatus = async (e) =>{
		await this.setState({
			selectStatus: e,
			checkBoxTitle:false
		})
		await this.onChangeSlectAll(false)
	}

   async componentDidMount() {
      await this.fetchProfile();
   //  await this.fetchDropDownMasterData("course");
   //  await this.fetchDropDownMasterData("leaveResult");
   //  await this.fetchDropDownMasterData("leaveYear");
   //  await this.fetchDropDownMasterData("studyStatus");
   //  await this.getAbstainTimeForApproverList()
    // await this.dropdownLeaveType()
   }

  render() {
    const { match } = this.props;
    const {
      currentPage,
      dataTalbe,
      columns,
      loading,
      pagination,
      valuesEndDate,
      disabledDateStart,
      endStartValues,
      preLoadSubmit,
      dropdownLeaveType,
      ddStartYear,
      ddEndYear,
      loadingFullpage,
      dataSelectTable,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    console.log("dataSelectTable", dataTalbe);
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          {/* <Breadcrumb.Item> */}
          <span style={{ fontSize: "18px" }}>
            การแก้ไขการลงเวลาทำงาน / รายการอนุมัติขอแก้ไขการลงเวลาทำงาน
          </span>
          {/* </Breadcrumb.Item> */}
        </div>
        <ModalConfirmForm 
         title={ModalConfirmFormTitle} 
         subtitle={ModalConfirmFormSubTitle}
         showModal={ModalConfirmFormShowModal} 
         btnOk={ModalConfirmFormBtnOk} 
         btnCancel={ModalConfirmFormBtnCancel}  
         submitToSend={ this.setToApprover }
         hideModal={ this.hideModalConfirm }
         valueConfirm = { ModalConfirmFormValue }
         ModalFormTextArea = {ModalFormTextArea}
         ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
      />
        <Spin spinning={loadingFullpage} delay={0}>
        <div className="card-container" id="page-profile">
          <div className="px-5 py-1 card-bg-green">
            <Form onSubmit={this.handleSubmit}>
              <Row
                gutter={16}
                type="flex"
                justify="left"
                align="top"
                className="box-color-white mb-0"
              >
                <Col xs={24} md={24} className="pt-2  mb-3">
                  <strong className="color-red">ค้นหา</strong>
                </Col>
                <Col xs={24} md={12}>
                     <Form.Item label={"ค้นหา"}>
                           { getFieldDecorator("searchKeyWord", {
                              initialValue: '',
                              rules:  [{ 
                                 required:false, 
                              }],
                           })(
                              <Input 
                                 className='block-news' 
                              />
                           )}
                     </Form.Item>
                  </Col>


                  <Col xs={ 24 } md={12} >
                     <Form.Item label={"สถานะ"}>
                        { getFieldDecorator("status", {
                           initialValue: "pending",
                           rules:  [{ 
                              message: 'กรุณากรอกหรือเลือก สถานะ',
                           }],
                        })(
                           <Select style={{ width: "100%" }} onChange={(e) => this.onChangeStatus(e)}>
                              <Option value="">ทั้งหมด</Option>
                              <Option value="approve">อนุมัติ</Option>
                              <Option value="pending">รออนุมัติ</Option>
                              <Option value="reject">ไม่อนุมัติ</Option>
                           </Select>
                        )}
                     </Form.Item>
                  </Col>

               
                <Col xs={24} md={24} align={"right"}>
                  <Button
                    type="primary"
                    id="btn-onsearch"
                    className="ml-2 color-white"
                    htmlType="submit"
                    disabled={preLoadSubmit}
                  >
                    ค้นหา
                  </Button>
                  {preLoadSubmit && <Spin size="small" />}
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-5 py-1 card-bg-green">
            <Row
              gutter={16}
              type="flex"
              justify="left"
              align="top"
              className="box-color-white"
            >
              <Col xs={24} md={12} className="pt-2 mb-3">
                <strong className="color-red">รายการอนุมัติขอแก้ไขการลงเวลาทำงาน</strong>
              </Col>
              <Col xs={24} md={24} align={"center"}>
                {
                  <Table
                    locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                    dataSource={dataTalbe}
                    columns={columns}
                    loading={loading}
                    // scroll={{ x: 'max-content' }}
                    // pagination={pagination}
                    // pagination={{ pageSize: dataTalbe.length }}
                    scroll={{ x: "1600", y: "550px" }}
                  //   pagination={{
                  //     total: pagination.total,
                  //     current: currentPage,
                  //     showSizeChanger: false,
                  //   }}
                     pagination={false}
                    onChange={this.paginationChange}
                    // onChange={this.paginationChange}
                    // rowCount={dataTalbe.length}
                  />
                }
              </Col>

              <Col xs={24} md={24} align={"center"} className="mt-4">
                  <Button type="primary" className="mx-2 btn-white-red" htmlType="submit" onClick={ this.submitReject }>
                     ไม่อนุมัติ
                  </Button>
                  <Button type="primary" className="ml-2 color-white btn-green" htmlType="submit" onClick={this.submitApprover}>
                     อนุมัติ
                  </Button>
               </Col>
            </Row>
          </div>
        </div>
        </Spin>
      </Container>
    );
  }
}

Dashboard.defaultProps = {
  autoFocus: false,
};

Dashboard.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedDashboard = Form.create()(Dashboard);

export default withApollo(WrappedDashboard);
